import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  type QuickBooksFieldMappingRowConstructor,
  QuickBooksFieldMappingRow,
} from './QuickBooksFieldMappingRow'

export const QuickBooksFieldMappingRowConstructorFactory =
  Factory.Sync.makeFactory<QuickBooksFieldMappingRowConstructor>({
    group: Factory.each(() => faker.lorem.word()),
    name: Factory.each(() => faker.lorem.word()),
    internalObjectKey: Factory.each(() => faker.lorem.slug()),
    customFieldId: null,
    customFieldLabel: null,
  })

export const QuickBooksFieldMappingRowFactory = EntityFactory(
  QuickBooksFieldMappingRow,
  QuickBooksFieldMappingRowConstructorFactory
)
